import React, { useEffect } from "react";
import { Switch, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { ICashDetail } from "../../../CashTypes";
import { useAlreadyCollectModel } from "./alreadyCollectModel";
import { useCashCollectModel } from "../../cashCollectModel";
import { TradeTypeEnum } from "@/types/FmsEnums";
import BillDetailRender from "@/views/vrmBill";




export function AlreadyCollectDataTable() {
    const {
        pgCfg,
        loadData,
        dataSource,
        selectedRowKeys,
        setSelectedRowKeys
    } = useAlreadyCollectModel();
    const {
        payMethodLabels,
        userTypeLabels,
    } = useCashCollectModel()



    const columns: ColumnsType<ICashDetail> = [
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '从属分支',
            dataIndex: 'branch',
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: '业务编号',
            dataIndex: 'tradeCode',
            render: (t, r) => BillDetailRender(t, r),
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '业务类型',
            dataIndex: 'tradeTypeName'
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '单位名称',
            dataIndex: 'partnerName',
            render: (v, r) => {
                return `[${userTypeLabels?.[r.partnerTypeCode ?? ''] ?? ''}]${v}`
            }
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '收款金额',
            dataIndex: 'billAmount',
            // render: (text, record) => (
            //     record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN) ? Math.abs(text) : text
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '收款账户',
            dataIndex: 'accountName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '支付类型',
            dataIndex: 'payType',
            render: v => payMethodLabels[v] ?? '暂无'
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '优惠类型',
            dataIndex: 'preferentialTypeName',
            render: v => v ?? '暂无'
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '创建时间',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '收款状态',
            dataIndex: 'status',
            render: (v) =>
                v === 0 ? "初始" :
                    v === 1 ? "已记账" :
                        v === 2 ? "已核销" :
                            ""
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '业务员',
            dataIndex: 'tradeOperator',
        },
        {
            align: "center",
            width: 260,
            ellipsis: true,
            title: '备注',
            dataIndex: 'note',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '从属机构',
            dataIndex: 'orgName',
        },

        // {
        //     title: '操作',
        //     dataIndex: 'state',
        //     render: (text, record) =>
        //     (
        //         <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked checked={text === 0} />
        //     )
        // },

    ];
    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: ICashDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
        />
    )
}
